module.exports = __webpack_public_path__ + "media/img/patterns/grid-vertical-ttb-light-2f95e3b0cfeec04c62b46e1801a151eb.png";